import { AnyAction } from 'redux';
import {
  GlobalActions,
  GlobalFeatureToggleReceivedAction,
  GlobalRegexReceivedAction,
  GlobalRoleDeterminedAction,
  StreckenTarifierungRequestEvents,
} from '@ps20-frontend/shop-integration-redux';
import { vorvertragVorschaedenErmitteltReducer } from '@ps20-frontend/reducers';
import {
  App,
  BaseTransientState,
  Rolle,
  VorvertragVorschaedenState,
} from '@ps20-frontend/frontend-models';
import { JhpActions } from '../jhpActions';

export interface TransientState extends BaseTransientState, Rolle, VorvertragVorschaedenState {}

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
): TransientState {
  switch (action.type) {
    case JhpActions.ZURUECK_ZUM_SHOP_MODAL_OPEN:
      return { ...sectionState, zurueckZumShopModalOpen: true };
    case JhpActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE:
      return { ...sectionState, zurueckZumShopModalOpen: false };
    case GlobalActions.TARIFIERUNG_HAS_STARTED:
      return { ...sectionState, tarifierungIsInProgress: true };
    case GlobalActions.TARIFIERUNG_HAS_ENDED:
      return { ...sectionState, tarifierungIsInProgress: false };
    case GlobalActions.ROLE_DETERMINED:
      return { ...sectionState, role: (action as GlobalRoleDeterminedAction).payload.role };
    case GlobalActions.FEATURE_TOGGLE_RECEIVED:
      return {
        ...sectionState,
        featureToggles: (action as GlobalFeatureToggleReceivedAction).payload,
      };
    case GlobalActions.REGEXPS_RECEIVED:
      return { ...sectionState, regexps: (action as GlobalRegexReceivedAction).payload };
    case GlobalActions.SET_PRICE_GUARANTEE:
      return { ...sectionState, priceGuarantee: action.payload };
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH:
      return { ...sectionState, priceGuarantee: false };
    case StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_JHP: {
      const payload = action.payload;
      if (payload?.response?.data?.taasStatus) {
        return {
          ...sectionState,
          fehlerCodeTaas: payload.response.data.taasStatus.fehlerCode,
        };
      }
      return { ...sectionState, fehlerCodeTaas: null };
    }
    case GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT: {
      return vorvertragVorschaedenErmitteltReducer(sectionState, action, {
        appId: App.JHP,
      });
    }
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    default:
      return sectionState;
  }
};
